import { IProductDetailState } from './types';

export const SLICE_NAMESPACE = 'product-detail';

export const productDetailInitialState: IProductDetailState = {
  data: null,
  loading: false,
  error: null,
};
